<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
          title="Marketing Website Package"
          startingPrice="$9,999"
          :overview="overview"
          :bullets="bullets"
          :note="note"
          cta-route="/schedule-a-meeting"
        />
        <MobileServicePackagesList />
      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'MarketingWebsitePackage',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'We create conversion-focused marketing websites designed to attract, engage, and convert customers. Built on a customized CMS template, this package helps you showcase services, display pricing, and collect data for campaigns faster while staying SEO-friendly.',
      bullets: [
        'A responsive, conversion-optimized website with clear CTAs',
        'Service and pricing pages designed to highlight offers',
        'Landing page templates for promotions and lead generation',
        'CMS setup for quick content and campaign updates',
        'SEO setup + Analytics to measure conversions',
      ],
      note:
        'This package is template-driven with brand customization. For custom UX/UI design with wireframes and mockups, consider our Custom UX/UI Design Package.',
    };
  },
};
</script>

<style scoped>
.service-section { padding: 2rem 1rem; background: #f9fafb; }

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col { min-width: 0; }

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>
